import moment from 'moment';
import { ApplicationStatus } from '../../pages/Compliance/Compliance.types';
import type { VerifyPolicyInput } from '../../redux/reducer/v2/verifyPolicy';
import type { ErrorListOutput } from '../../types';

export interface ValidatePolicySuccessResponse {
  validateCoviePolicy: {
    validation: {
      errors: {
        id: string;
        message: string;
        type: string;
      }[];
    };
    application: {
      id: string;
      status: ApplicationStatus;
    };
  };
}

export interface ValidatePolicyErrorResponse {
  validateCoviePolicy: ErrorListOutput & {
    validation: never;
    application: never;
  };
}

export type ValidatePolicyResponse =
  | ValidatePolicySuccessResponse
  | ValidatePolicyErrorResponse;

export const VALIDATE_POLICY_QUERY = (
  {
    firstName,
    lastName,
    email,
    address,
    buildingUnit,
    buildingId,
    leaseStart,
    leaseEnd,
  }: VerifyPolicyInput,
  {
    policy_id,
    utm_source,
  }: {
    policy_id: string;
    utm_source?: string;
  },
) => {
  const name = `${firstName} ${lastName}`;
  const buildingIdCheck = buildingId ? `buildingId: "${buildingId}",` : '';

  return `mutation {
  validateCoviePolicy(
    input: {
      policyId: "${policy_id}",
      name: "${name}",
      firstName: "${firstName}",
      lastName: "${lastName}",
      email: "${email}",
      buildingUnit: "${buildingUnit || ''}",
      ${utm_source ? `utmSource: "${utm_source}",` : ''}
      ${buildingIdCheck}
      address :{
        street: "${address.street}",
        addressNumber: "${address.addressNumber}",
        postalCode: "${address.postalCode}",
        municipality: "${address.municipality}",
        region: ${address.state}
      }
      leaseStart:"${moment(leaseStart).format('YYYY-MM-DD')}",
      leaseEnd:"${moment(leaseEnd).format('YYYY-MM-DD')}"
    }
  ) {
    ...on ApplicationWithValidationOutput {
      validation {
        errors {
          id
          message
          type
        }
      }
      application {
        id
        status
      }
    }
    ...on ErrorListOutput {
      errors{
        type
        message
      }
    }
  }
}
`;
};
